// Rich text (the event's description, an announcement) is a Draft.js document saved as JSON.

// The document a text holds, or null for any other text, which is the plain text it is.
export function draftDocument(text) {
  let document
  try { document = JSON.parse(text) } catch { return null }
  const isDocument = Array.isArray(document?.blocks) && document.blocks.every(line => typeof line?.text === 'string')
    && Boolean(document.entityMap) && typeof document.entityMap === 'object'
  return isDocument ? document : null
}

// Whether a document shows anything: a written line, or an image or an embed with an address. An editor left empty still saves a
// document.
export const documentHasContent = document => document.blocks.some(line => line.text.trim() !== '' || line.entityRanges?.some(range => {
  const entity = document.entityMap[range.key]
  return ['IMAGE', 'EMBEDDED_LINK'].includes(entity?.type) && Boolean(entity.data?.src)
}))
